import React, { useMemo } from "react";

import type { ResolvedQuantityButtonsDeviceConfig } from "@intelligems/ig-types";

import { QuantityButtonsViewProps } from "../index";
import { QuantityButtonsContextType } from "../types";

import { QuantityButtonsContext } from "./QuantityButtonsContext";

export interface QuantityButtonsContextProviderProps
  extends QuantityButtonsViewProps {
  widget: ResolvedQuantityButtonsDeviceConfig;
  hasMediaQuery?: boolean;
  children: React.ReactNode;
}

export const QuantityButtonsContextProvider = (
  props: QuantityButtonsContextProviderProps
) => {
  const {
    formatter,
    config,
    widget,
    quantity,
    calculateButtonState,
    onQuantityChange,
    hasMediaQuery,
    children,
  } = props;

  const value = useMemo<QuantityButtonsContextType>(
    () => ({
      config,
      widget,
      quantity,
      formatter,
      calculateButtonState,
      onQuantityChange,
      hasMediaQuery,
    }),
    [
      config,
      widget,
      quantity,
      formatter,
      calculateButtonState,
      onQuantityChange,
      hasMediaQuery,
    ]
  );

  return (
    <QuantityButtonsContext.Provider value={value}>
      {children}
    </QuantityButtonsContext.Provider>
  );
};
